import { css } from '@emotion/react'
import { memo } from 'react'

const rootStyles = css({
    flexDirection: 'column',
    position: 'relative',
    overflow: 'hidden',
    display: 'flex',
    height: '100%',
    width: '100%',
    alignItems: 'center',
    justifyContent: 'center',
    padding: '20px',
})

const shortcutLabelStyles = css({
    fontWeight: 600,
    fontSize: 14,
    textAlign: 'center',
    marginBottom: 20,
    color: '#666',
})

const emojiImageStyles = css({
    maxWidth: '100%',
    maxHeight: '300px',
    objectFit: 'contain',
    borderRadius: 4,
})

export interface EmojiViewerProps {
    emoji: string
    shortcut?: string
    type?: string // needed for openEmojiViewerDialog
}

const EmojiViewer = memo((props: EmojiViewerProps) => {
    const { emoji, shortcut } = props

    return (
        <div css={rootStyles}>
            {shortcut && (
                <span css={shortcutLabelStyles} data-testid="Emoji__Shortcut">
                    Shortcut :{shortcut}
                </span>
            )}
            <img
                src={emoji}
                css={emojiImageStyles}
                data-testid="Image__EmojiModal"
                alt={shortcut ? `:${shortcut}:` : 'Emoji'}
            />
        </div>
    )
})

export default EmojiViewer
